import { render, staticRenderFns } from "./ContractsComponent.vue?vue&type=template&id=477704d4"
import script from "./ContractsComponent.vue?vue&type=script&lang=js"
export * from "./ContractsComponent.vue?vue&type=script&lang=js"
import style0 from "./ContractsComponent.vue?vue&type=style&index=0&id=477704d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports